import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3a01df41")

_pushScopeId("data-v-3a01df41")
const _hoisted_1 = { slot: "fixed" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "greeting"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Boas compras, ")
const _hoisted_5 = {
  key: 1,
  class: "greeting"
}
const _hoisted_6 = { class: "neighborhood-name" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "Saldo", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "border" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")

  return (_openBlock(), _createBlock("header", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", null, [
        ($props.user.name)
          ? (_openBlock(), _createBlock("h2", _hoisted_3, [
              _hoisted_4,
              _createVNode("span", null, _toDisplayString($options.formatName($props.user.name)), 1)
            ]))
          : (_openBlock(), _createBlock("h2", _hoisted_5, "Boas compras")),
        _createVNode("div", {
          class: "neighborhood",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.goToNeighborhood && $options.goToNeighborhood(...args)))
        }, [
          _createVNode(_component_ion_icon, {
            icon: $setup.location,
            class: "location-icon"
          }, null, 8, ["icon"]),
          _createVNode("p", _hoisted_6, _toDisplayString($options.neighborhood.name), 1),
          _createVNode(_component_ion_icon, {
            icon: $setup.caretDown,
            class: "caret-icon"
          }, null, 8, ["icon"])
        ])
      ]),
      ($props.user?.cashbackValue || $props.user?.cashbackValue === 0)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "cashback-value",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.openWallet && $options.openWallet(...args)))
          }, [
            _hoisted_7,
            _createVNode("h3", null, _toDisplayString($options.cashbackValue), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_8
  ]))
})